import PeerFiles from '../../peers/PeerFiles';
import NotificationTextMixin from '../notification-text-mixin';
import {getUserName} from '../../peers/peer-utils';


export default {
  components: {
    PeerFiles
  },

  mixins: [
    NotificationTextMixin
  ],

  computed: {
    peerName() {
      if (this.notification?.data?.peer) {
        return getUserName(this.notification.data.peer);
      }
      return null;
    },

    filesLength() {
      return this.notification?.data?.files?.length || 0;
    },

    files() {
      return this.$tc('files', this.filesLength);
    }
  },

  methods: {
    resolve() {
      const resolve = this.notification?.resolve;
      if (typeof resolve === 'function') {
        resolve();
      }
    },

    reject(error) {
      const reject = this.notification?.reject;
      if (typeof reject === 'function') {
        reject(error);
      }
    }
  }
};
